!function() {
  class t extends HTMLElement {
    constructor() {
      super(), Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [], 
      this.container = this.querySelector("[data-slider]"), this.source = this.getAttribute("data-source") || "shopify";
    }
    connectedCallback() {
      this.container && ("rebuy" === this.source ? (this.trackRebuyProductView(), this.loadRebuyProducts()) : Shopify?.recentlyViewed?.length > 0 && this.loadProducts());
    }
    async trackRebuyProductView() {
      const t = location.pathname.match(/\/products\/([^\/]+)/);
      if (t) try {
        const e = {
          subject: "user",
          verb: "viewed",
          noun: "product",
          product_handle: t[1]
        };
        this.dataset.customerId && (e.customer_id = this.dataset.customerId);
        let o = sessionStorage.getItem("rebuy_uuid");
        o || (o = crypto.randomUUID(), sessionStorage.setItem("rebuy_uuid", o)), e.uuid = o, 
        await fetch("https://rebuyengine.com/api/v2/analytics/event", {
          method: "POST",
          headers: {
            "X-Rebuy-User-Token": this.dataset.apiKey,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(e)
        });
      } catch (t) {
        console.warn("Could not track Rebuy product view:", t);
      }
    }
    async loadProducts() {
      const t = Shopify.recentlyViewed.map(t => this.loadProduct(t.split("#")[0]));
      await Promise.all(t);
      const e = this.querySelector("vanilla-slider");
      e && "function" == typeof e.update && e.update();
    }
    async loadRebuyProducts() {
      try {
        const t = {
          format: "pretty",
          key: this.dataset.apiKey
        };
        if (this.dataset.customerId) t.shopify_customer_id = this.dataset.customerId; else {
          let e = sessionStorage.getItem("rebuy_uuid");
          if (!e) return;
          t.uuid = e;
        }
        const e = new URLSearchParams(t), o = await fetch(`https://rebuyengine.com/api/v1/products/viewed?${e}`);
        if (!o.ok) throw new Error(`HTTP error! status: ${o.status}`);
        const r = await o.json();
        if (r.data && r.data.length > 0) {
          const t = r.data.map(t => this.loadRebuyProduct(t));
          await Promise.all(t);
          const e = this.querySelector("vanilla-slider");
          e && "function" == typeof e.update && e.update();
        }
      } catch (t) {
        console.warn("Could not load Rebuy products:", t);
      }
    }
    show() {
      this.classList.remove("hidden");
    }
    async loadProduct(t) {
      const e = location.href.match("/products/([^?]+)");
      if (!e || t !== e[1]) return fetch(`${Shopify.routes.root || "/"}products/${t}?view=card-no-count`).then(e => {
        if (!e.ok) throw 404 === e.status && (Shopify.recentlyViewed = Shopify.recentlyViewed.filter(e => e !== t), 
        localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed))), 
        Error(e.statusText);
        return e.text();
      }).then(e => {
        const o = (new DOMParser).parseFromString(e, "text/html").querySelector("product-card");
        if (!o) return void console.warn(`Product card view not found for ${t}, skipping to prevent full page injection`);
        const r = document.createElement("div");
        r.classList.add("slide", "w-grid", "[--columns:6]", "[--offsets:0]", "[--spacing-gutter:var(--spacing-gutter-sm)]", "laptop:[--columns:4]", "tablet:[--columns:2.4]"), 
        r.setAttribute("data-slide", !0), r.innerHTML = o.outerHTML, this.container.appendChild(r);
      }).then(() => {
        this.show();
      }).catch(e => {
        console.warn("Could not load product: " + t + ". " + e);
      });
    }
    async loadRebuyProduct(t) {
      const e = location.href.match("/products/([^?]+)");
      if (!e || t.handle !== e[1]) try {
        const e = await fetch(`${Shopify.routes.root || "/"}products/${t.handle}?view=card-no-count`);
        if (!e.ok) throw new Error(e.statusText);
        const o = await e.text(), r = (new DOMParser).parseFromString(o, "text/html").querySelector("product-card");
        if (!r) return void console.warn(`Product card view not found for ${t.handle}, skipping to prevent full page injection`);
        const s = document.createElement("div");
        s.classList.add("slide", "w-grid", "[--columns:6]", "[--offsets:0]", "[--spacing-gutter:var(--spacing-gutter-sm)]", "laptop:[--columns:4]", "tablet:[--columns:2.4]"), 
        s.setAttribute("data-slide", !0), s.innerHTML = r.outerHTML, this.container.appendChild(s), 
        this.show();
      } catch (e) {
        console.warn("Could not load Rebuy product: " + t.handle + ". " + e);
      }
    }
  }
  customElements.get("recently-viewed") || customElements.define("recently-viewed", t);
}();